// A small burst of Bailey's four-point stars from an element, for the moment
// something Bailey made lands. Nothing under reduced motion.
const reduced = () => { try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches } catch (e) { return false } }

export const sparkleFrom = (el, count = 10) => {
  if (!el || reduced() || typeof document === 'undefined') return
  const r = el.getBoundingClientRect()
  const x = r.left + r.width / 2
  const y = r.top + r.height / 2
  let layer = document.querySelector('.sx-fx')
  if (!layer) { layer = document.createElement('div'); layer.className = 'sx-fx'; document.body.appendChild(layer) }
  const nodes = []
  for (let i = 0; i < count; i += 1) {
    const a = (i / count) * Math.PI * 2 + Math.random() * 0.5
    const d = Math.max(r.width, r.height) * 0.35 + 20 + Math.random() * 36
    const n = document.createElement('span')
    n.className = `sx-spark${i % 3 === 1 ? ' is-gold' : i % 3 === 2 ? ' is-violet' : ''}`
    n.style.left = `${x}px`
    n.style.top = `${y}px`
    n.style.setProperty('--dx', `${Math.cos(a) * d}px`)
    n.style.setProperty('--dy', `${Math.sin(a) * d}px`)
    n.style.setProperty('--rot', `${Math.round(Math.random() * 180)}deg`)
    n.style.setProperty('--d', `${Math.round(Math.random() * 80)}ms`)
    layer.appendChild(n)
    nodes.push(n)
  }
  setTimeout(() => nodes.forEach((n) => n.remove()), 1100)
}

// Bring an element into view inside the one box that scrolls around it (a
// tool panel), never the frames around that: scrollIntoView would also move
// the studio itself on a phone, leaving a gap under it
export const scrollWithin = (el, { block = 'center', smooth = true } = {}) => {
  if (!el || typeof window === 'undefined') return
  let box = el.parentElement
  while (box && box !== document.body) {
    const oy = window.getComputedStyle(box).overflowY
    if ((oy === 'auto' || oy === 'scroll') && box.scrollHeight > box.clientHeight) break
    box = box.parentElement
  }
  if (!box || box === document.body) return
  const b = box.getBoundingClientRect()
  const r = el.getBoundingClientRect()
  let top = box.scrollTop
  if (block === 'start') top += r.top - b.top - 8
  else if (block === 'center') top += (r.top + r.height / 2) - (b.top + b.height / 2)
  else if (r.top < b.top) top += r.top - b.top - 8
  else if (r.bottom > b.bottom) top += Math.min(r.bottom - b.bottom + 8, r.top - b.top - 8)
  top = Math.max(0, Math.min(top, box.scrollHeight - box.clientHeight))
  if (Math.abs(top - box.scrollTop) < 1) return
  if (box.scrollTo) box.scrollTo({ top, behavior: smooth && !reduced() ? 'smooth' : 'auto' })
  else box.scrollTop = top
}
